<template lang="pug">
    .prematch.columns.is-multiline.is-gapless
        .column.is-12.match-header
            .columns.is-gapless.is-mobile.is-multiline
                .column.is-narrow.columns
                  a.match-link(:href="matchURL" target="_blank")
                    span.icon.is-small
                      i.fas.fa-futbol.fa-lg
                .column.columns.is-gapless.is-vcentered.stats.is-full-mobile.is-mobile.is-multiline
                  .column.is-one-quarter-desktop.is-half-touch
                    .columns.is-mobile.is-centered.is-variable.is-1
                      .column.is-narrow O/U
                      .column.is-narrow
                        .tags.has-addons
                          span.tag(
                            v-for="item in stat.OU"
                            :class="{ 'has-background-success': item.value === true, 'has-background-danger': item.value === false }"
                          ) {{ item.key }}
                  .column.is-one-quarter-desktop.is-half-touch
                    .columns.is-mobile.is-centered.is-variable.is-1
                      .column.is-narrow AH
                      .column.is-narrow
                        .tags.has-addons
                          span.tag(
                            v-for="item in stat.AH"
                            :class="{ 'has-background-success': item.value === true, 'has-background-danger': item.value === false }"
                          ) {{ item.key }}
                  .column.is-one-quarter-desktop.is-half-touch(v-if="moveStat")
                    .columns.is-centered-desktop.is-variable.is-1.is-0-touch.is-multiline
                      .column.has-text-danger.is-narrow.is-full-touch Move
                      .column.is-narrow(v-for="(type, typeKey) in moveStat")
                        .columns.is-variable.is-1.is-mobile
                          .column.is-narrow {{ typeKey === "OU" ? "O/U" : "AH" }}
                          template(v-for="(part, partKey) in moveStat[typeKey]")
                            .column.is-narrow(v-for="(count, res) in moveStat[typeKey][partKey]" v-if="count > 0")
                              span.tag(
                                :class="{ 'has-background-success': res === 'success', 'has-background-danger': res === 'failure' }"
                              ) {{ partKey }}({{ count }})
                  .column.is-one-quarter-desktop.is-half-touch(v-if="fixedStat")
                    .columns.is-centered-desktop.is-variable.is-1.is-0-touch.is-multiline
                      .column.has-text-danger.is-narrow.is-full-touch Fixed
                      .column.is-narrow(v-for="(type, typeKey) in fixedStat")
                        .columns.is-variable.is-1.is-mobile
                          .column.is-narrow {{ typeKey }}
                          template(v-for="(part, partKey) in fixedStat[typeKey]")
                            .column.is-narrow(v-for="(count, res) in fixedStat[typeKey][partKey]" v-if="count > 0")
                              span.tag(
                                :class="{ 'has-background-success': res === 'success', 'has-background-danger': res === 'failure' }"
                              ) {{ partKey }}({{ count }})
                .column.is-narrow.companies.columns.is-gapless.is-vcentered
                  .column
                    .select
                      select(v-model="companyId")
                        option(v-for="item of companies" :value="item._id") {{ item.name }}
                .column.is-narrow-desktop.columns.is-gapless
                  .column
                    .match-time.is-flex(@click.stops="showHistory=!showHistory")
                      .title.is-5.countdown(:class="[countdownClass]") {{ countdown }}
        .column.is-12.match-body
            .columns.is-gapless
                .column.columns.is-gapless
                    .column.columns.is-mobile
                      span {{ match.homeName }} ({{ match.homeWinCoef }})
                .column
                  .title.is-6.has-text-centered {{ match.league }}
                .column.columns.is-gapless
                    .column.columns.is-mobile.has-text-right
                      span ({{ match.awayWinCoef }}) {{ match.awayName }}
        .column.is-12.match-history(v-if="showHistory && companyData")
            .columns.is-multiline
                .column.has-text-centered
                    table.table.is-striped.is-bordered.is-narrow.is-hoverable.is-fullwidth.is-hidden-touch
                      thead
                        tr
                          th.has-text-centered(rowspan=2) F/H
                          th.has-text-centered(colspan=6) Over/Under
                          th.has-text-centered(colspan=6) Asian Handicap
                        tr
                          th.has-text-centered(colspan=3) HT
                          th.has-text-centered(colspan=3) FT
                          th.has-text-centered(colspan=3) HT
                          th.has-text-centered(colspan=3) FT
                      tbody
                        tr(v-for="[key, data] of odds")
                          td.has-text-centered(:class="{ 'has-text-danger': key === 'Live' }") {{ key }}
                          td.has-text-centered(
                            v-for="col of data"
                            :class=`{
                                'has-background-success': key !== 'First' && col.diff === true,
                                'has-background-danger': key !== 'First' && col.diff === false,
                                'has-background-light': col.diff === null,
                                'total-background': key !== 'First' && col.type === 'total'
                            }`
                          )
                            span.icon.has-text-success(v-show="col.diff === true")
                              i.fas(:class=`{
                                  'fa-arrow-down': col.type !== 'total',
                                  'fa-arrow-up': col.type === 'total'
                              }`)
                            span.icon.has-text-danger(v-show="col.diff === false")
                              i.fas(:class=`{
                                  'fa-arrow-down': col.type === 'total',
                                  'fa-arrow-up': col.type !== 'total'
                              }`)
                            span {{ col.value }}

                    table.table.is-striped.is-bordered.is-narrow.is-hoverable.is-fullwidth.is-hidden-desktop
                      template(v-for="[ti, type] of ['Over/Under', 'Asian Handicap'].entries()")
                        template(v-for="[pi, part] of ['HT', 'FT'].entries()")
                          thead
                            tr
                              th.has-text-centered(colspan=4) {{ part }} {{ type }}
                          tbody
                            tr(v-for="[key, data] of odds")
                              td(:class="{ 'has-text-danger': key === 'Live' }") {{ key }}
                              td.has-text-centered(
                                v-for="col of data.slice((pi * 3) + (ti * 6), 3 + (pi * 3) + (ti * 6))"
                                :class=`{
                                    'has-background-success': key !== 'First' && col.diff === true,
                                    'has-background-danger': key !== 'First' && col.diff === false,
                                    'has-background-light': col.diff === null,
                                    'total-background': key !== 'First' && col.type === 'total'
                                }`
                              )
                                span.icon.has-text-success(v-show="col.diff === true")
                                  i.fas(:class=`{
                                      'fa-arrow-down': col.type !== 'total',
                                      'fa-arrow-up': col.type === 'total'
                                  }`)
                                span.icon.has-text-danger(v-show="col.diff === false")
                                  i.fas(:class=`{
                                      'fa-arrow-down': col.type === 'total',
                                      'fa-arrow-up': col.type !== 'total'
                                  }`)
                                span {{ col.value }}

</template>

<script>
import moment from "moment";

// column sort map
const parts = ["HT", "FT"];
const types = ["OU", "handicap"];
const keys = ["Live", "First"];
const params = ["over", "total", "under"];

export default {
  name: "TickerMatch",
  props: {
    match: Object,
    source: Object,
    active: Number
  },
  data: () => ({
    showHistory: false,
    companyId: false
  }),
  watch: {
    companyData() {
      if (this.companyData && this.companyData.companyId && !this.companyId) {
        this.companyId = +this.companyData.companyId;
      }
    },
    companyIdFilter(n) {
      const company = this.companies.find(({ id }) => +id === +n);
      this.companyId = !n || !company ? this.companies[0].id : company.id;
    }
  },
  computed: {
    companyIdFilter() {
      return this.$store.state.prematch.filters.companyId;
    },
    companies() {
      const companies = this.match.data.map(({ companyId }) => companyId);
      return this.$store.getters.prematchCompanies.filter(row =>
        companies.includes(row.id)
      );
    },
    companyData() {
      return (
        this.match.data.find(
          ({ companyId }) => +companyId === +this.companyId
        ) ||
        this.match.data[0] ||
        false
      );
    },
    countdown() {
      return moment(new Date(this.match.start)).fromNow(true);
    },
    countdownClass() {
      let result = "";
      const left = (this.match.start - Date.now()) / 1000 / 60;
      if (left >= 0 && left < 10) result = "has-text-danger";
      if (left >= 10 && left <= 15) result = "has-text-warning";
      return result;
    },
    stat() {
      return types.reduce((acc, type) => {
        const t = type === "handicap" ? "AH" : "OU";
        if (!acc[t]) acc[t] = [];
        parts.forEach(part => {
          const value = this.companyData.odds[part][type].live.total.diff;
          acc[t].push({ key: part, value });
        });
        return acc;
      }, {});
    },
    fixedStat() {
      const companyFixed = this.match.fixed.filter(
        row => +row.companyId === +this.companyId
      );
      const grouped = companyFixed.reduce((acc, row) => {
        const t = row.type === "handicap" ? "AH" : "OU";
        if (!acc[t]) acc[t] = {};
        if (!acc[t][row.part])
          acc[t][row.part] = { success: 0, failure: 0, no_diff: 0 };
        const key =
          row.diff === null ? "no_diff" : row.diff ? "success" : "failure";
        acc[t][row.part][key] += 1;
        return acc;
      }, {});
      return Object.keys(grouped).length ? grouped : false;
    },
    moveStat() {
      const companyMove = this.match.move.filter(
        row => +row.companyId === +this.companyId
      );
      const grouped = companyMove.reduce((acc, row) => {
        const t = row.type === "handicap" ? "AH" : "OU";
        if (!acc[t]) acc[t] = {};
        if (!acc[t][row.part])
          acc[t][row.part] = { success: 0, failure: 0, no_diff: 0 };
        const key =
          row.diff === null ? "no_diff" : row.diff ? "success" : "failure";
        acc[t][row.part][key] += 1;
        return acc;
      }, {});
      return Object.keys(grouped).length ? grouped : false;
    },
    odds() {
      const res = {};
      Object.keys(this.companyData.odds).forEach(part => {
        Object.keys(this.companyData.odds[part]).forEach(type => {
          Object.keys(this.companyData.odds[part][type]).forEach(key => {
            if (!res[part]) res[part] = {};
            if (!res[part][type]) res[part][type] = {};
            if (!res[part][type][key])
              res[part][type][key] = this.companyData.odds[part][type][key];
          });
        });
      });
      const result = keys.map(key => {
        const data = [];
        types.forEach(type => {
          parts.forEach(part => {
            params.forEach(param => {
              data.push({
                value: parseFloat(
                  res[part][type][key.toLowerCase()][param].value
                ),
                diff: res[part][type][key.toLowerCase()][param].diff,
                type: param
              });
            });
          });
        });
        return [key, data];
      });
      return result;
    },
    matchURL() {
      return `${this.source.url}/3in1odds/${this.match._id}.html`;
    }
  },
  methods: {
    partClass(part, type = "background") {
      if (!["HT", "FT"].includes(part)) return "";
      return `has-${type}-${part === "HT" ? "success" : "warning"}`;
    }
  },
  mounted() {
    if (this.companyId === false && this.companies.length) {
      const cid = this.companyIdFilter;
      let company = this.companies[0];
      if (cid) company = this.companies.find(({ id }) => +id === +cid);
      this.companyId = company.id;
    }
  }
};
</script>

<style lang="scss" scoped>
.prematch {
  background-color: rgba(0, 0, 0, 0.3);
  overflow: hidden;

  &.is-active {
    .match-header {
      .match-link {
        animation: rotate 3s infinite;
      }
    }
  }

  .match-header {
    color: #000;
    background: #d7d7d7;
    background: linear-gradient(
      0deg,
      rgba(120, 120, 120, 1) -100%,
      rgba(215, 215, 215, 1) 100%
    );
    transition: all 0.3s linear;

    & > .columns {
      & > .column {
        &:first-child {
          display: flex;
          align-items: center;
          padding-left: 0.3rem !important;
          padding-right: 0.3rem !important;
        }

        &.stats {
          @media screen and (max-width: $tablet) {
            order: 2;
            padding: 0.3rem 0 !important;

            & > .is-full-touch {
              & > .columns {
                padding: 0 0.5rem;

                & > .column {
                  flex: 0 !important;
                }
              }
            }

            & > .is-half-touch {
              & > .is-0-touch {
                padding: 1rem;
                & > .column {
                  margin: 0;
                  padding: 0;
                }
              }
            }
          }
        }

        &.companies {
          @media screen and (max-width: $tablet) {
            order: 1;
          }
        }

        &.columns {
          margin: 0 !important;
        }

        .select {
          display: flex;
          align-items: center;

          select {
            font-size: 0.8em;
            &:not([multiple]) {
              padding-right: 1.5em;
            }
          }

          &:not(.is-multiple) {
            height: 2em;
          }
        }

        .select:not(.is-multiple):not(.is-loading)::after {
          right: 0.6em;
          width: 0.425em;
          height: 0.425em;
          margin-top: -0.2375em;
        }

        &:last-child {
          align-items: center;
          @media screen and (max-width: $tablet) {
            //flex: 1;

            .match-time {
              .title {
                font-size: 1.2rem;
                padding-bottom: 0.2rem;
                font-weight: bold;
              }
            }
          }

          .match-time {
            cursor: pointer;
            padding: 0 0.7rem;
            .title {
              opacity: 0.8;
            }
          }
        }
      }
    }

    .match-link,
    .title {
      color: #000;
    }

    .match-link {
      display: inline-flex;
      padding: 0.5rem;
      border-radius: 50%;
      background-color: transparent;
      transition: all 0.2s linear;

      &:hover {
        background-color: rgba(0, 0, 0, 0.2);
      }
    }
  }

  .match-body {
    color: #fff;
    background: #283238;
    transition: all 0.3s linear;

    .columns {
      align-items: center;

      .has-text-right {
        flex-direction: row-reverse;
      }
    }

    & > .columns {
      padding: 0.2rem 0;
      .is-gapless:not(:last-child) {
        margin-bottom: 0;
      }

      & > .column {
        @media screen and (max-width: $tablet) {
          padding: 0.2rem 0 !important;
        }
        & > span.is-active {
          text-shadow: 1px -1px #ff3860, -1px 1px #ff3860, -1px 0px #ff3860,
            0 1px #ff3860, 1px 0 #ff3860, 0 -1px #ff3860;
        }
        &.team-level-1 {
          background: #00bb8a;
        }
        &.team-level-2 {
          background: #ffdd57;
          color: #000;
        }
        &.team-level-3 {
          background: #d33254;
        }
        & > .column {
          flex: 1;
          &:first-child {
            flex: 5;
            padding: 0 0.3rem !important;
          }
        }
      }

      .penalty-card {
        font-size: 1rem;
        border-radius: 3px;
        height: 1.3rem;
        width: 1.1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $defaultColor;

        &.yellow {
          background-color: yellow;
          color: $cardFontColor;
        }
        &.red {
          background-color: red;
        }
      }
    }
  }

  .match-history {
    .table {
      table-layout: fixed;
      margin: 0;

      .has-background-success {
        background-color: lighten($successColor, 40%) !important;
        &.total-background {
          background-color: lighten($successColor, 33%) !important;
        }
      }
      .has-background-danger {
        background-color: lighten($errorColor, 20%) !important;
        &.total-background {
          background-color: lighten($errorColor, 13%) !important;
        }
      }
      .has-background-light {
        background-color: lighten($sublinkColor, 25%) !important;
        &.total-background {
          background-color: lighten($sublinkColor, 20%) !important;
        }
      }

      .icon {
        position: absolute;
        margin-left: -1.5rem;
      }
    }
  }

  .penalty-card {
    font-size: 1rem;
    border-radius: 3px;
    height: 1.3rem;
    width: 1.1rem;
    display: inline-block;
    text-align: center;
    color: $defaultColor;

    &.yellow {
      background-color: yellow;
      color: $cardFontColor;
    }
    &.red {
      background-color: red;
    }
  }
}

@keyframes blink {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
